import { render } from "./student-messages.vue?vue&type=template&id=0b68885a"
import script from "./student-messages.vue?vue&type=script&lang=js"
export * from "./student-messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__